import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUserApiRequest } from "../../services";
import { TCreateUser } from "../../types";

export const useCreateUserApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createUserInfo: TCreateUser) =>
      createUserApiRequest(createUserInfo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-account"],
      });
    },
  });
};
